// src/pages/MainLandingPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/branding/B4W_main.webp';
import '../styles/MainLanding.css';

const STEPS = [
  {
    icon: '🗡️',
    title: 'Solve the daily word',
    text: 'Each dawn, a new Rune appears over Wordia. Crack it in fewer guesses to earn more troops for your army.',
  },
  {
    icon: '🏰',
    title: 'Rally your campaign',
    text: 'Create or join a campaign with friends. Compete over a 3, 5, or 7-day cycle for the crown.',
  },
  {
    icon: '👑',
    title: 'Claim the throne',
    text: 'Spend coins on blessings, curses, and illusions in the market. Outwit your rivals and rule.',
  },
];

export default function MainLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing">
      <div className="landing-scrim" />

      {/* HERO */}
      <header className="landing-hero">
        <div className="landing-hero-inner">
          <img src={logo} alt="Battle for Wordia" className="landing-logo" />
          <h1 className="landing-title">Battle for Wordia</h1>
          <p className="landing-tagline">
            A daily word game with a war for the throne underneath it. Solve, scheme, and
            conquer your friends one guess at a time.
          </p>
          <div className="landing-ctas">
            <button className="landing-btn primary" onClick={() => navigate('/register')}>
              Join the Fight
            </button>
            <button className="landing-btn ghost" onClick={() => navigate('/login')}>
              Log In
            </button>
          </div>
        </div>
        <div className="landing-scroll-hint" aria-hidden="true">▾</div>
      </header>

      {/* HOW IT WORKS */}
      <section className="landing-section">
        <h2 className="landing-section-title">How it works</h2>
        <div className="landing-steps">
          {STEPS.map((step, i) => (
            <div className="landing-step" key={step.title}>
              <div className="landing-step-icon" aria-hidden="true">{step.icon}</div>
              <div className="landing-step-num">Step {i + 1}</div>
              <h3 className="landing-step-title">{step.title}</h3>
              <p className="landing-step-text">{step.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="landing-final">
        <h2 className="landing-section-title">Ready to march?</h2>
        <p className="landing-final-text">It's free, it's daily, and the throne is up for grabs.</p>
        <button className="landing-btn primary large" onClick={() => navigate('/register')}>
          Create your account
        </button>
        <p className="landing-login-link">
          Already enlisted?{' '}
          <button className="landing-text-link" onClick={() => navigate('/login')}>Log in</button>
        </p>
      </section>

      <footer className="landing-footer">
        <span>Battle for Wordia</span>
      </footer>
    </div>
  );
}
